import Div from "@jumbo/shared/Div/Div";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import {
  Autocomplete,
  Box,
  Button,
  InputAdornment,
  Pagination,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import JumboDdMenu from "@jumbo/components/JumboDdMenu/JumboDdMenu";
import EditIcon from "@mui/icons-material/Edit";
import Heading from "app/pages/Component/Heading";
import { getAllProduct } from "app/redux/actions/Masters/Products";
import AllApis from "app/Apis/apis";
import { Axios } from "index";
import Swal from "sweetalert2";
import Loader from "app/components/Loader";

export default function ListProduct() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("desc");
  const [categoryList, setCategoryList] = useState([]);
  const [filterCategory, setFilterCategory] = useState("");
  const [sortBy, setSortBy] = useState("created_at");

  const { allProduct, TotalPage, loading } = useSelector(
    (state) => state.productReducer
  );
  const { userData } = useSelector((state) => state.userReducer);
  const Permission = userData?.current_data?.role_id?.current_data?.permissions;

  //debouncing for search
  const handleSearch = (value) => {
    setPage(1);
    dispatch(getAllProduct(value, sort, sortBy, 1, ""));
  };

  const debouncedHandleSearch = debounce(handleSearch, 500);

  useEffect(() => {
    if (searchTerm !== "") {
      debouncedHandleSearch(searchTerm);
    }
    return () => {
      debouncedHandleSearch.cancel();
    };
  }, [searchTerm]);

  const handleSort = (property) => {
    setSort(sort == "asc" ? "desc" : "asc");
    setSortBy(property);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleItemAction = (menuItem) => {
    switch (menuItem.action) {
      case "edit":
        navigate("/dashboards/master/product/edit", {
          state: { ...menuItem.data },
        });
        break;
    }
  };

  const changeStatus = async (e, row) => {
    try {
      const response = await Axios.patch(AllApis.product.status(row._id), {
        isActive: e.target.checked,
      });
      if (response) {
        Swal.fire({
          title: "Updated",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
        dispatch(getAllProduct(searchTerm, sort, sortBy, page, filterCategory));
      }
    } catch (error) {
      Swal.fire({
        title: error.message,
        icon: "error",
        timer: 1000,
        showConfirmButton: false,
      });
    }
  };

  const handleFilter = () => {
    dispatch(getAllProduct(searchTerm, sort, sortBy, page, filterCategory));
  };
  const handleClear = () => {
    setFilterCategory("");
    dispatch(getAllProduct(searchTerm, sort, sortBy, page, ""));
  };

  useEffect(() => {
    dispatch(getAllProduct(searchTerm, sort, sortBy, page, ""));
  }, [sort, page]);

  useEffect(async () => {
    try {
      const categoryData = await Axios.get(`${AllApis.category.dropdown}`);
      setCategoryList(categoryData?.data?.data);
    } catch (error) {}
  }, []);

  return (
    <Div sx={{ mt: -4 }}>
      <Heading Name={"Product Master"} />
      {loading && <Loader />}
      <Typography variant="h1" sx={{ mt: 2 }}>
        Filter
      </Typography>
      <Div sx={{ width: "19%", mt: 2 }}>
        <Typography variant="h5">Category Name</Typography>
        <Autocomplete
          size="small"
          id="tags-standard"
          options={categoryList || []}
          value={
            categoryList.filter((item) => item._id == filterCategory)?.[0] ||
            null
          }
          getOptionLabel={(option) => option?.category_name}
          onChange={(e, newValue) =>
            setFilterCategory(newValue == null ? "" : newValue?._id)
          }
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.category_name}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              sx={{
                width: "100%",
              }}
            />
          )}
        />
      </Div>
      <Box sx={{ mt: 4 }}>
        <Button
          variant="contained"
          sx={{ marginRight: 1 }}
          onClick={() => handleFilter()}
        >
          Apply
        </Button>
        <Button variant="outlined" onClick={() => handleClear()}>
          Clear
        </Button>
      </Box>
      <Div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          id="search"
          type="search"
          label="Search"
          value={searchTerm}
          size="small"
          onChange={(e) => {
            setSearchTerm(e.target.value);
            if (e.target.value == "") {
              setSort("desc");
              setSortBy("created_at");
              dispatch(getAllProduct("", "desc", "created_at", 1, ""));
            }
          }}
          sx={{ width: 300, mb: 5, mt: 4 }}
          InputProps={{
            endAdornment: (
              <Div sx={{ cursor: "pointer" }}>
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              </Div>
            ),
          }}
        />
        <Div>
          {/* <Button
            variant="contained"
            sx={{
              mr: 2,
              p: 1,
              pl: 4,
              pr: 4,
            }}
            onClick={() => setLogModalOpen(true)}
          >
            Logs
          </Button> */}
          {Permission?.["product"]?.["add"] && (
            <Button
              variant="contained"
              size="small"
              sx={{
                mr: 2,
                p: 1,
                pl: 4,
                pr: 4,
              }}
              onClick={() => navigate("/dashboards/master/product/add")}
            >
              Add Product
            </Button>
          )}
        </Div>
      </Div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#7352C7", color: "white" }}>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Product Image
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  onClick={() => handleSort("current_data.created_by.name")}
                  direction={sort}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  Category Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  onClick={() => handleSort("current_data.product_name")}
                  direction={sort}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  Product Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  onClick={() => handleSort("current_data.sku")}
                  direction={sort}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  SKU
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  onClick={() => handleSort("current_data.hsn_code.hsn_code")}
                  direction={sort}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  HSN Code
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  onClick={() => handleSort("current_data.hsn_code.gst_percentage")}
                  direction={sort}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  GST%
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  onClick={() => handleSort("current_data.created_by.name")}
                  direction={sort}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  Created By
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Status
              </TableCell>
              {Permission?.["product"]?.["edit"] && (
                <TableCell
                  sx={{
                    textAlign: "left",
                    minWidth: "150px",
                    verticalAlign: "middle",
                    color: "white",
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {allProduct?.map((row, i) => (
              <TableRow key={i}>
                <TableCell
                  sx={{
                    textAlign: "left",
                    position: "relative", // Set position to relative for absolute positioning of overlay
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <img
                      style={{
                        width: "100px",
                        height: "100px",
                      }}
                      src={`${process.env.REACT_APP_IMAGE_URL}/${row?.current_data?.product_images?.[0]}`}
                    />
                    {row?.current_data?.product_images?.length > 1 && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100px",
                          height: "100px",
                          backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust the alpha value for transparency
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "white",
                          fontSize: "16px",
                        }}
                      >
                        {`${row?.current_data?.product_images?.length - 1}+`}{" "}
                        {/* Replace with the actual property holding the number */}
                      </div>
                    )}
                  </div>
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform:"capitalize"
                  }}
                >
                  {row?.current_data?.category?.category_name}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform:"capitalize"
                  }}
                >
                  {row?.current_data?.product_name}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform:"capitalize"
                  }}
                >
                  {row?.current_data?.sku}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.hsn_code?.hsn_code}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.hsn_code?.gst_percentage}%
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform:"capitalize"
                  }}
                >
                  {row?.current_data?.created_by?.name}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  <Switch
                    checked={row?.current_data?.isActive}
                    size="small"
                    disabled={!Permission?.["product"]?.["edit"]}
                    onChange={(e) => changeStatus(e, row)}
                    style={{
                      color: row?.current_data?.isActive
                        ? "#7352C7"
                        : "lightgrey",
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </TableCell>
                {Permission?.["product"]?.["edit"] && (
                  <TableCell sx={{ textAlign: "left" }}>
                    <JumboDdMenu
                      icon={<MoreHorizIcon />}
                      menuItems={[
                        {
                          icon: <EditIcon />,
                          title: "Edit Product",
                          action: "edit",
                          data: row,
                        },
                      ]}
                      onClickCallback={handleItemAction}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Pagination
          count={TotalPage || 1}
          page={page}
          onChange={handleChangePage}
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            p: 1,
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
          }}
        />
      </TableContainer>
      {/* <LogsModal
        open={isLogModalOpen}
        onClose={() => setLogModalOpen(false)}
      /> */}
    </Div>
  );
}
